import { ConsumerPostSubmissionApprovedView } from './components/consumer-post-submission-approved-view/consumer-post-submission-approved-view.component'

export const ConsumerPostSubmissionApproved = () => {
  return <ConsumerPostSubmissionApprovedView />
}
